import { productDetailPath, shopPathForProduct } from './productPaths';

export { productDetailPath, shopPathForProduct };

function haystack(p) {
  return `${p.name || ''} ${p.id || ''} ${p.type || ''} ${p.subcategory || ''} ${p.description || ''} ${p.category || ''}`.toLowerCase();
}

/** Match name, id, type, subcategory, description, or category slug (substring, case-insensitive). */
export function productMatchesSearchQuery(p, rawQuery) {
  const q = String(rawQuery || '').trim().toLowerCase();
  if (!q) return false;
  const id = String(p.id || '').trim().toLowerCase();
  if (id && (id === q || id.includes(q))) return true;
  const h = haystack(p);
  if (h.includes(q)) return true;
  const words = q.split(/\s+/).filter(Boolean);
  if (words.length <= 1) return false;
  return words.every((w) => h.includes(w));
}
